(ns common.resource.user
  (:require [clojure.set :refer [rename-keys]]
            [clojure.string :as str]
            [common.db.effects.http :refer [jsonify]]
            [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.user/get-token
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]} [_ payload]]
    {:fx [[:http
           {:method :post
            :uri (url-tpl/render :api/get-token url-context)
            :params payload
            :on-success [:resource.user/merge-value]
            :on-failure [:resource.user/get-token-failure]}]]}))

(rf/reg-event-fx :resource.user/merge-value
  (fn [{:keys [db]} [_ user]]
    (let [user* (rename-keys user {:auth-token :token})]
      (cond-> {:db (update db :resource.user/me merge user*)}
        (:token user*) (assoc :fx [[:qhttp/set-auth-token! (:token user*)]])))))

(rf/reg-event-db :resource.user/get-token-failure
  (fn [db _]
    db))

(rf/reg-event-fx :resource.user/get-me
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [resource.user/token url-context]} _]
    {:fx [[:http {:method :get
                  :uri (url-tpl/render :api/my-account url-context)
                  :params {:embed (jsonify ["role", "flags"])}
                  :headers {"Authorization" token}
                  :on-success [:resource.user/get-me-success]
                  :on-failure [:resource.user/get-me-failure]}]
          [:invalidate-queries {:queryKey ["user"]}]]}))

(rf/reg-event-db
  :resource.user/get-me-success
  (fn [db [_ user]]
    (update db :resource.user/me merge user)))

(rf/reg-event-db :resource.user/get-me-failure
  (fn [db _]
    db))

;; Patch
(rf/reg-event-fx :resource.user/patch-me
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [resource.user/token url-context]} [_ payload]]
    {:fx [[:http {:method :patch
                  :params (select-keys payload [:name :email :privacySettingsAccepted])
                  :uri (url-tpl/render :api/my-account url-context)
                  :headers {:Authorization token}
                  :on-success [:resource.user/patch-me-success]
                  :on-failure [:resource.user/patch-me-failure]}]]}))

(rf/reg-event-fx :resource.user/patch-me-success
  (fn [_ _]
    {:fx [[:invalidate-queries {:queryKey ["user"]}]]}))

(rf/reg-event-db :resource.user/patch-me-failure
  (fn [db _]
    db))

;; Post
(rf/reg-event-fx :resource.user/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ payload]]
    {:fx [[:http
           {:method :post
            :params payload
            :uri (url-tpl/render :api/users url-context)
            :headers {:Authorization (:resource.user/token cofx)}
            :on-success [:resource.user/post-success]
            :on-failure [:resource.user/post-failure]}]]}))

(rf/reg-event-db :resource.user/post-success
  (fn [db _]
    db))

(rf/reg-event-db :resource.user/post-failure
  (fn [db _]
    db))

;; Delete
(rf/reg-event-fx :resource.user/delete
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [resource.user/token url-context]} [_ id]]
    {:fx [[:http
           {:method :delete
            :uri (url-tpl/render :api/user-role (assoc url-context :user-id id))
            :headers {:Authorization token}
            :on-success [:resource.user/delete-success]
            :on-failure [:resource.user/delete-failure]}]]}))

(rf/reg-event-db :resource.user/delete-success
  (fn [db _]
    db))

(rf/reg-event-db :resource.user/delete-failure
  (fn [db _]
    db))

;; Change role
(rf/reg-event-fx :resource.user/change-role
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [resource.user/token url-context]} [_ payload]]
    {:fx [[:http
           {:method :put
            :params (select-keys payload [:roleId])
            :uri (url-tpl/render :api/user-role (assoc url-context :user-id (:id payload)))
            :headers {:Authorization token}
            :on-success [:resource.user/change-role-success]
            :on-failure [:resource.user/change-role-failure]}]]}))

(rf/reg-event-db :resource.user/change-role-success
  (fn [db _]
    db))

(rf/reg-event-db :resource.user/change-role-failure
  (fn [db _]
    db))

(rf/reg-event-fx :resource.user/request-reset-password
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]} [_ payload]]
    {:fx [[:http
           {:method :post
            :uri (url-tpl/render :api/request-reset-password url-context)
            :params payload
            :on-success [:resource.user/request-reset-password-success]
            :on-failure [:resource.user/request-reset-password-failure]}]]}))

(rf/reg-event-db :resource.user/request-reset-password-success
  (fn [db _]
    db))

(rf/reg-event-db :resource.user/request-reset-password-failure
  (fn [db _]
    db))

(rf/reg-event-fx :resource.user/get-reset-password-user
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]}]
    {:fx [[:http
           {:method :get
            :uri (url-tpl/render :api/reset-password url-context)
            :on-success [:resource.user/get-reset-password-user-success]
            :on-failure [:resource.user/get-reset-password-user-failure]}]]}))

(rf/reg-event-db :resource.user/get-reset-password-user-success
  (fn [db _]
    db))

(rf/reg-event-db :resource.user/get-reset-password-user-failure
  (fn [db _]
    db))

(rf/reg-event-fx :resource.user/reset-password
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]} [_ payload]]
    {:fx [[:http
           {:method :post
            :params payload
            :uri (url-tpl/render :api/reset-password url-context)
            :on-success [:resource.user/reset-password-success]
            :on-failure [:resource.user/reset-password-failure]}]]}))

(rf/reg-event-db :resource.user/reset-password-success
  (fn [db _]
    db))

(rf/reg-event-db :resource.user/reset-password-failure
  (fn [db _]
    db))

;; Subs
(rf/reg-sub :resource.user/me
  (fn [db]
    (:resource.user/me db)))

(rf/reg-sub :resource.user/sso-enabled
  :<- [:resource.user/me]
  (fn [me]
    (boolean (:ssoEnabled me))))

(rf/reg-sub :resource.user/token
  :<- [:resource.user/me]
  (fn [me]
    (some->> (:token me) (str "lemonpi "))))

(rf/reg-sub :resource.user/refresh-token
  :<- [:resource.user/me]
  (fn [me]
    (:refresh-token me)))

(rf/reg-sub :resource.user/roles
  :<- [:resource.user/me]
  (fn [me]
    (:roles me)))

(rf/reg-sub :resource.user/has-one-role?
  :<- [:resource.user/roles]
  (fn [roles _]
    (= (count roles) 1)))

(defn get-merged-permissions [me]
  (merge
   (get-in me [:role :permissions])
   (when-let [az (:azPermissions me)]
     {:az az})))

(rf/reg-sub :resource.user/permissions
  :<- [:resource.user/me]
  (fn [me]
    (get-merged-permissions me)))

(defmulti allowed? (fn [required _]
                     (if (sequential? required)
                       :one-of
                       :single)))

(defmethod allowed? :one-of [required permissions]
  (some #(allowed? % permissions) required))

(defmethod allowed? :single [required permissions]
  (if required
    (let [path (->> (str/split required #"\.")
                    (map keyword))]
      (= "allowed" (get-in permissions path)))
    true))

(rf/reg-sub :resource.user/allowed?
  :<- [:resource.user/permissions]
  (fn [permissions [_ required]]
    (allowed? required permissions)))

(rf/reg-sub
  :resource.user/permission->allowed?
  :<- [:resource.user/permissions]
  (fn [permissions [_ requireds]]
    (reduce (fn [acc r]
              (assoc acc r (allowed? r permissions)))
            {} requireds)))

(rf/reg-sub :resource.user/agency-id
  (fn [db]
    (get-in db [:resource.user/me :agencyId])))

(rf/reg-event-fx :resource.user/remove-last-viewed-advertiser-id
  (fn [_]
    {:fx [[:localstorage/remove ["last-viewed-advertiser-id"]]]}))
